import { atom, useAtom } from 'jotai';

const hasSearchedForDestinationDeliveries = atom(false);

export const useHasSearchedForDestinationDeliveries = () => useAtom(hasSearchedForDestinationDeliveries);
